export enum ShipmentDateFilterType {
  createdAt = 'createdAt',
  pickUpDate = 'pickUpDate'
}
